import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, spacing } from 'ui/theme';
import { body1 } from 'ui/theme/typography';
import { mediumShadow } from 'ui/theme/shadows';

export const DateRangePickerWrapper = styled.div`
  width: ${pxToRem(640)};
  left: -${pxToRem(3.5)};
  border-radius: ${spacing.half};
  ${mediumShadow};
`;

interface Input {
  isPromoted: boolean;
}

export const InputBar = styled.div<Input>`
  background: ${(props) => (props.isPromoted ? colors.purple100 : colors.grey1)};
  display: flex;
  padding: ${spacing.base};
  border-radius: ${(props) =>
    props.isPromoted
      ? `${spacing.half} ${spacing.half} 0 0`
      : `0 0 ${spacing.half} ${spacing.half}`};
`;

export const InputBarText = styled.div<Input>`
  ${body1};
  color: ${(props) => (props.isPromoted ? colors.white : colors.textPrimary)};
  padding: 0 ${spacing.threeQuarter};
  margin-top: ${spacing.half};
`;

export const CalendarAndRelativeMenuWrapper = styled.div`
  display: grid;
  grid-template-columns: ${pxToRem(262)} 1fr;
  grid-gap: ${spacing.single};
`;

export const CalendarWrapper = styled.div`
  margin-top: ${spacing.half};
  margin-bottom: ${spacing.half};
`;

export const TimeZonePickerWrapper = styled.div`
  padding-left: ${spacing.half};
  display: flex;
  align-items: center;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing.base};
  border-top: ${spacing.single} solid ${colors.grey15};
`;
